export enum HomeContainerCodes {
  HEADER = 'level1_header',
}
